import React from 'react';

export const SignUpText: React.FC<{text: string}> = (props: {text: string}) => {
    return <p className='ms-loyalty-signup__text'>{props.text}</p>;
};
